import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";

/**
 * GET Pro check digit detail API call using Axios
 */

export const deploymentStatusApi = async () => {
  const response = await axios.get(`${getUrl(ApiType.DEPLOYMENT_STATUS)}`);
  return response;
};
